import { Flex, Text, Badge, Box } from '@chakra-ui/core'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { InputWithIcon } from './InputWithIcon'
import { ViewModeSwitch } from './ViewModeSwitch'
import { Plus, Search } from 'lucide-react'
import React from 'react'
import { AppTheme } from 'constants/interfaces'
import LocaleText from 'components/LocaleText'

interface BoardHeaderProps {
  title: string
  count: number
  searchPlaceholder?: string
  createButtonText: string
  onSearch: (value: string) => void
  onCreate: () => void
  viewMode?: 'grid' | 'table'
  onViewModeChange?: () => void
  theme?: AppTheme | null
  showViewMode?: boolean
  searchValue?: string
}

export const BoardHeader: React.FC<BoardHeaderProps> = ({
  title,
  count,
  createButtonText,
  onSearch,
  onCreate,
  viewMode,
  onViewModeChange,
  theme,
  showViewMode = true,
  searchValue = '',
}) => {
  return (
    <Flex
      justify="space-between"
      align="center"
      flexWrap={{ base: 'wrap', lg: 'nowrap' }}
      style={{ gap: '10px' }}
      mb={4}
    >
      <Flex alignItems="center" style={{ columnGap: '10px' }}>
        <Text fontSize="2xl" fontWeight="bold" textTransform="capitalize">
          <LocaleText text={title} />
        </Text>
        <Badge rounded="full" bg="transparent" color="black" border="1px solid black">
          {count}
        </Badge>
      </Flex>

      {/* Mobile Create Button */}
      <NoFocusButton
        w="max-content"
        maxWidth="150px"
        bg={theme?.elementsColor}
        color="white"
        rounded="md"
        background={theme?.elementsColor}
        onClick={onCreate}
        display={{ base: 'flex', md: 'none' }}
        style={{ gap: '5px' }}
        _hover={{ opacity: 0.8 }}
      >
        <Text fontSize="14px" display={{ base: 'none', lg: 'block' }}>
          {createButtonText}
        </Text>
      </NoFocusButton>

      <Flex align="center" style={{ gap: '16px' }} justify="space-between" w={{ base: '100%', md: 'auto' }}>
        {showViewMode && (
          <Box display={{ base: 'none', md: 'block' }}>
            <ViewModeSwitch viewMode={viewMode || 'grid'} onViewModeChange={onViewModeChange} />
          </Box>
        )}

        <Box w={{ base: '100%', md: '300px' }}>
          <InputWithIcon
            borderRadius="5px"
            icon={<Search />}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch(e.target.value)}
            value={searchValue}
          />
        </Box>

        {/* Desktop Create Button */}
        <NoFocusButton
          w="max-content"
          maxWidth="150px"
          bg={theme?.elementsColor}
          color="white"
          rounded="md"
          background={theme?.elementsColor}
          onClick={onCreate}
          display={{ base: 'none', md: 'flex' }}
          style={{ gap: '5px' }}
          _hover={{ opacity: 0.8 }}
        >
          <Text fontSize="14px" display={{ base: 'none', md: 'block' }}>
            {createButtonText}
          </Text>
        </NoFocusButton>
      </Flex>
    </Flex>
  )
}
